/* eslint-disable no-param-reassign */
window.merchantos.shop = {
  setShop(shopID) {
    if (window.isGriffin()) {
      window.StencilWebAPI.shop.setShop(shopID);
    }
    window.merchantos.utils.openUrl(
      `/choose_register.php?form_name=change_shops&shop_id=${shopID}`
    );
  },

  setRegister(registerID, url) {
    if (window.isGriffin()) {
      window.StencilWebAPI.shop.setRegister(registerID);
    }
    if (!url) {
      url = `/register.php?form_name=attach_to_register&register_id=${registerID}`;
    }
    if ($('#lock_computer').is(':checked')) {
      url += '&lock_computer=1';
    }
    window.merchantos.utils.openUrl(url);
  },
};
